import { HelpCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

const TEMPLATE_VARIABLES = [
  {
    variable: 'clientFirstName',
    description: "Client's first name",
    example: 'John',
  },
  {
    variable: 'clientLastName',
    description: "Client's last name",
    example: 'Smith',
  },
  {
    variable: 'clientFullName',
    description: "Client's full name",
    example: 'John Smith',
  },
  {
    variable: 'firmName',
    description: 'Firm name',
    example: 'Finch Legal',
  },
  {
    variable: 'attorneyName',
    description: 'Assigned attorney name',
    example: 'Sarah Johnson',
  },
  {
    variable: 'matterName',
    description: 'Matter display name',
    example: 'Smith v. Acme Corp',
  },
  {
    variable: 'appointmentDate',
    description: 'Next appointment date',
    example: 'January 15, 2025',
  },
  {
    variable: 'appointmentTime',
    description: 'Next appointment time',
    example: '2:00 PM',
  },
];

interface TemplateVariableReferenceProps {
  onInsert?: (variable: string) => void;
}

export const TemplateVariableReference = ({
  onInsert,
}: TemplateVariableReferenceProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 text-zinc-500">
          <HelpCircle className="h-4 w-4" />
          Variables
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="start">
        <div className="space-y-3">
          <div>
            <h4 className="font-medium text-sm text-zinc-900">
              Available Variables
            </h4>
            <p className="text-xs text-zinc-500">
              Use {'{{variableName}}'} syntax in your template
            </p>
          </div>

          <div className="max-h-64 overflow-y-auto space-y-1">
            {TEMPLATE_VARIABLES.map((v) => (
              <button
                key={v.variable}
                type="button"
                onClick={() => onInsert?.(v.variable)}
                className="w-full text-left rounded-md px-2 py-1.5 hover:bg-zinc-100 transition-colors group"
              >
                <div className="flex items-center justify-between">
                  <code className="text-xs font-mono bg-zinc-100 px-1.5 py-0.5 rounded text-blue-600 group-hover:bg-white">
                    {`{{${v.variable}}}`}
                  </code>
                  {onInsert && (
                    <span className="text-xs text-zinc-400 opacity-0 group-hover:opacity-100 transition-opacity">
                      Click to insert
                    </span>
                  )}
                </div>
                <p className="text-xs text-zinc-500 mt-0.5">{v.description}</p>
                <p className="text-xs text-zinc-400 italic">
                  Example: {v.example}
                </p>
              </button>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
